import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../data/api";

const SyncContext = createContext(null);

export function SyncProvider({ children }) {
  const [syncStatus, setSyncStatus] = useState({
    is_syncing: false,
    has_data: false,
    last_sync: null,
    progress: "",
    product_count: 0,
  });

  const fetchStatus = useCallback(async () => {
    try {
      const { data } = await api.getSyncStatus();
      setSyncStatus(data);
    } catch (e) {
      console.error("Error fetching sync status:", e);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 5000);
    return () => clearInterval(interval);
  }, [fetchStatus]);

  const triggerSync = async () => {
    try {
      await api.triggerSync();
      setSyncStatus((prev) => ({ ...prev, is_syncing: true, progress: "Iniciando..." }));
    } catch (e) {
      console.error("Error triggering sync:", e);
    }
  };

  return (
    <SyncContext.Provider value={{ syncStatus, triggerSync, refreshStatus: fetchStatus }}>
      {children}
    </SyncContext.Provider>
  );
}

export function useSync() {
  return useContext(SyncContext);
}
